module.exports = require("skypager-util/lib/string");


//////////////////
// WEBPACK FOOTER
// external "skypager-util/lib/string"
// module id = 3
// module chunks = 0